import { useEffect } from "react";
import styled from "styled-components";

const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
  max-height: 100vh;
`;

const History = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8rem' }}>
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/01.jpg" alt="History of the Blue Heron Sangha" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/03.jpg" alt="Original four herons" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/05.jpg" alt="Sangha teachers" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/07.jpg" alt="Estes park retreat" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/09.jpg" alt="First Blue Heron Sangha retreat" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/13.jpg" alt="Grailville Retreat" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/15.jpg" alt="2007 Sangha pics" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/16.jpg" alt="Estes park retreat 2007" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/17.jpg" alt="Day of Mindfulness 2008" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/21.jpg" alt="Buddhism Central Ohio art exhibit" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/25.jpg" alt="New Years Day 2008" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/29.jpg" alt="Days of Mindfulness 2009 10 11" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/31.jpg" alt="Thich Not Here 2009" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/33.jpg" alt="Mindful Cooking at Hisako's 2009" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/37.jpg" alt="Retreat 2010" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/41.jpg" alt="Estes park retreat 2010" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/45.jpg" alt="Wonderful way retreat 2011" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/73.jpg" alt="Ten year anniversary 2016" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/77.jpg" alt="Saint Peter & Paul retreat 2017" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/81.jpg" alt="Saint Peter & Paul retreat 2018" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/85.jpg" alt="Saint Peter & Paul retreat 2019" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/87.jpg" alt="Sangha on zoom 2020" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/89.jpg" alt="Honoring 20 years" />
        <StyledImage src="https://d3lar93zsohcaj.cloudfront.net/history/91.jpg" alt="This is it. To be continued..." />
    </div>
  )
}

export default History;